import './heading.css';

function Heading()
{
    return (
        <div>
            <h1>About</h1>
        </div>
    );
}

export default Heading;